<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" epub:type="pagebreak" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" epub:type="pagebreak" id="piii" role="doc-pagebreak"></span>Invested</h1>
<h1 class="bk1">How Three Centuries of Stock Market Advice Reshaped Our Money, Markets, and Minds</h1>
<p class="bkau"><span class="sm">PAUL</span> <span class="sm">CROSTHWAITE,</span> <span class="sm">PETER</span> <span class="sm">KNIGHT,</span> <span class="sm">NICKY</span> <span class="sm">MARSH,</span> <span class="sm">HELEN</span> <span class="sm">PAUL,</span> <span class="sm">AND</span> <span class="sm">JAMES</span> <span class="sm">TAYLOR</span></p>
<p class="bkpub"><span class="sm">THE</span> <span class="sm">UNIVERSITY</span> <span class="sm">OF</span> <span class="sm">CHICAGO</span> <span class="sm">PRESS</span>    <span class="sm">CHICAGO</span> <span class="sm">AND</span> <span class="sm">LONDON</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-crosthwaite-0003.vue?4c9d7c4a